import {
  IonContent,
  IonIcon,
  IonItem,
  IonLabel,
  IonList,
  IonListHeader,
  IonMenu,
  IonMenuToggle,
  IonNote,
  IonRow,
  IonCol,
  IonImg,
  IonItemDivider,
  //IonToggle
} from '@ionic/react';

import React from 'react';
import { useLocation } from 'react-router-dom';
import {
  homeOutline,
  homeSharp,
  receiptOutline,
  receiptSharp,
  paperPlaneOutline,
  paperPlaneSharp,
  personOutline,
  personSharp,
  logOutOutline,
  logOutSharp,

  helpOutline,
  helpSharp,
  callOutline,
  callSharp,
  mailOutline,
  mailSharp,
  informationOutline,
  informationSharp,
  //moonSharp,
  //moonOutline
} from 'ionicons/icons';
import { CallNumber } from '@ionic-native/call-number';
import './Menu.css';

import { getDataJWT } from '../utils/functions';
import { RESOURCES } from '../constants/system';

interface AppPage {
  url: string;
  iosIcon: string;
  mdIcon: string;
  title: string;
}

const appPages: AppPage[] = [
  {
    title: 'Inicio',
    url: '/home',
    iosIcon: homeOutline,
    mdIcon: homeSharp
  },
  {
    title: 'Progreso',
    url: '/progress',
    iosIcon: receiptOutline,
    mdIcon: receiptSharp
  },
  {
    title: 'Mensajería',
    url: '/messenger/received',
    iosIcon: paperPlaneOutline,
    mdIcon: paperPlaneSharp
  },
  {
    title: 'Mi perfil',
    url: '/profile/userdata',
    iosIcon: personOutline,
    mdIcon: personSharp
  }
];

const labels: AppPage[] = [
  {
    title: getDataJWT() ? getDataJWT().claims.empresa[0].telefono : "",
    url: '/phone',
    iosIcon: callOutline,
    mdIcon: callSharp
  },
  {
    title: getDataJWT() ? getDataJWT().claims.empresa[0].correo : "",
    url: '/email',
    iosIcon: mailOutline,
    mdIcon: mailSharp
  }
];

const Menu: React.FC = () => {
  const location = useLocation();

  /*function toggleDarkModeHandler(){
    document.body.classList.toggle("dark");

  }*/

  function menuClick(url: any){
    if (url === "/login") {
      localStorage.removeItem("token_codesii")
      window.location.href = "/login";
    }

    if (url === "/phone") {
      CallNumber.callNumber(getDataJWT() ? getDataJWT().claims.empresa[0].telefono : "" , true)
        .then(res => console.log('Launched dialer!', res))
        .catch(err => console.log('Error launching dialer', err));
    }
  }

  return (
    <IonMenu contentId="main" disabled={!getDataJWT().claims}>
      <IonContent>
        <IonRow className="ion-padding-top">
          <IonCol className="ion-align-self-center">
            <img className="circleImg" alt="" style={{ width: '40%' }} src={`${ RESOURCES }usuarios/${ getDataJWT() ? getDataJWT().claims.imagen : "" }`} />
            <h2 className="ion-text-center">{ getDataJWT() ? getDataJWT().claims.username : "" }</h2>
            <h5 className="ion-text-center">{ getDataJWT() ? getDataJWT().claims.email : "" }</h5>
          </IonCol>
        </IonRow>

        <IonItemDivider></IonItemDivider>
          <IonList id="inbox-list">
            {appPages.map((appPage, index) => {
              return (
                <IonMenuToggle key={index} autoHide={false}>
                  <IonItem onClick={() => menuClick(appPage.url)} className={location.pathname.split("/")[1] === appPage.url.split("/")[1] ? 'selected' : ''} routerLink={appPage.url} routerDirection="none" lines="none" detail={false}>
                    <IonIcon slot="start" ios={appPage.iosIcon} md={appPage.mdIcon} />
                    <IonLabel>{appPage.title}</IonLabel>
                  </IonItem>
                </IonMenuToggle>
              );
            })}
            <IonMenuToggle autoHide={false}>
              <IonItem onClick={() => menuClick("/login")}  lines="none">
                <IonIcon slot="start" ios={logOutOutline} md={logOutSharp} />
                <IonLabel>Cerrar sesion</IonLabel>
              </IonItem>
            </IonMenuToggle>
          </IonList>

          <IonList id="labels-list">
            <IonListHeader>Info</IonListHeader>
            {labels.map((appPage, index) => {
              return (
                <IonMenuToggle key={index} autoHide={false}>
                  <IonItem onClick={() => menuClick(appPage.url)} lines="none">
                    <IonIcon slot="start" ios={appPage.iosIcon} md={appPage.mdIcon} />
                    <IonLabel>{appPage.title}</IonLabel>
                  </IonItem>
                </IonMenuToggle>
              );
            })}

            {/*<IonMenuToggle autoHide={false}>
              <IonItem>
                <IonIcon slot="start" ios={moonOutline} md={moonSharp} />
                <IonLabel>Dark Mode</IonLabel>
                <IonToggle
                  color="primary"
                  name="darkMode"
                  onIonChange={toggleDarkModeHandler}
                />
              </IonItem>
            </IonMenuToggle>*/}
          </IonList>

      </IonContent>
    </IonMenu>
  );
};

export default Menu;
